import { render, staticRenderFns } from "./UserLevelManagement.vue?vue&type=template&id=1fae6669&scoped=true"
import script from "./UserLevelManagement.vue?vue&type=script&lang=js"
export * from "./UserLevelManagement.vue?vue&type=script&lang=js"
import style0 from "./UserLevelManagement.vue?vue&type=style&index=0&id=1fae6669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae6669",
  null
  
)

export default component.exports